<template>
  <v-row justify="center" v-show="syncDialog" class="dialog-container">
    <v-dialog v-model="syncDialog" persistent max-width="300">
      <v-card tile flat>
        <v-card-title class="headline">Visszaállítás</v-card-title>
        <v-card-text>{{ syncablecount }} esemény szinkronizálásra került</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn depressed tile @click="syncDialogClose">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import eventBus from "@/eventBus";
import CONSTANTS from "@/constants";

export default {
  computed:{
    ...mapState('ui', ['syncDialog']),
    ...mapState('game', ['syncablecount']),
  },
  methods: {
    ...mapMutations('ui', ['SET_SYNCDIALOG']),
    syncDialogClose: function () {
      this.SET_SYNCDIALOG(false);
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
    },
  }
}
</script>

<style scoped>

</style>
